'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

var NavigationResponderBehaviors = {};
NavigationResponderBehaviors.IHasStateInitialization = {
    name: 'IHasStateInitialization',
    methods: ['initializeByNavigator']
};
NavigationResponderBehaviors.IHasStateValidation = {
    name: 'IHasStateValidation',
    methods: ['validate']
};
NavigationResponderBehaviors.IHasStateValidationAsync = {
    name: 'IHasStateValidationAsync',
    extends: ['IHasStateValidation'],
    methods: ['prepareValidation']
};
NavigationResponderBehaviors.IHasStateValidationOptional = {
    name: 'IHasStateValidationOptional',
    extends: ['IHasStateValidation'],
    methods: ['willValidate']
};
NavigationResponderBehaviors.IHasStateValidationOptionalAsync = {
    name: 'IHasStateValidationOptionalAsync',
    extends: ['IHasStateValidationAsync', 'IHasStateValidationOptional'],
    methods: []
};
NavigationResponderBehaviors.IHasStateRedirection = {
    name: 'IHasStateRedirection',
    extends: ['IHasStateValidation'],
    methods: ['redirect']
};
NavigationResponderBehaviors.IHasStateSwap = {
    name: 'IHasStateSwap',
    methods: ['willSwapToState', 'swapOut', 'swapIn']
};
NavigationResponderBehaviors.IHasStateTransition = {
    name: 'IHasStateTransition',
    methods: ['transitionIn', 'transitionOut']
};
NavigationResponderBehaviors.IHasStateUpdate = {
    name: 'IHasStateUpdate',
    methods: ['updateState']
};

NavigationResponderBehaviors.implementsBehaviorInterface = function implementsBehaviorInterface(object, _interface) {
    if (object.navigatorBehaviors === undefined || !(object.navigatorBehaviors instanceof Array)) {
        // The input interface is not set on object's navigatorBehaviors.
        return false;
    }

    var inheritanceChain = NavigationResponderBehaviors.getInterfaceInheritanceChain(_interface);
    var methodsToBeImplemented = NavigationResponderBehaviors.getInterfaceMethods(inheritanceChain);
    var i = void 0;
    var method = void 0;
    var length = methodsToBeImplemented.length;

    for (i = 0; i < length; i++) {
        method = methodsToBeImplemented[i];

        if (object[method] === undefined || typeof object[method] !== 'function') {
            return false;
        }
    }

    return true;
};

NavigationResponderBehaviors.getInterfaceInheritanceChain = function (_interface, existingChain) {
    var chain = existingChain || [];
    var extendingInterface = void 0;
    var i = void 0;
    var interfaceObject = NavigationResponderBehaviors[_interface];

    if (interfaceObject === undefined || (typeof interfaceObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(interfaceObject)) !== 'object') {
        //		console.log('behaviorObject for interface is undefined ', interface );
        return chain;
    }

    chain.push(_interface);
    var extendsArray = interfaceObject.extends;
    if (extendsArray === undefined) {
        //		console.log('extendsArray for interface is undefined, the chain ends here ', interface, chain);
        return chain;
    }

    var length = extendsArray.length;

    for (i = 0; i < length; i++) {
        extendingInterface = extendsArray[i];
        if (chain.indexOf(extendingInterface) === -1) {
            // We did not yet extend this interface, so continue to follow the chain
            NavigationResponderBehaviors.getInterfaceInheritanceChain(extendingInterface, chain);
        }
    }

    return chain;
};

NavigationResponderBehaviors.getInterfaceMethods = function (interfaces) {
    if (interfaces === undefined || !Array.isArray(interfaces)) {
        // No valid input
        return [];
    }

    var combinedInterfacesChain = [];
    var _interface = void 0;
    var i = void 0;
    var length = interfaces.length;
    var interfaceObject = void 0;
    var interfaceMethods = void 0;
    var j = void 0;
    var methodsLength = void 0;
    var method = void 0;
    var methods = [];

    for (i = 0; i < length; i++) {
        _interface = interfaces[i];
        NavigationResponderBehaviors.getInterfaceInheritanceChain(_interface, combinedInterfacesChain);
    }

    length = combinedInterfacesChain.length;
    for (i = 0; i < length; i++) {
        _interface = combinedInterfacesChain[i];
        interfaceObject = NavigationResponderBehaviors[_interface];
        interfaceMethods = interfaceObject.methods;
        if (interfaceObject !== undefined && (typeof interfaceObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(interfaceObject)) === 'object' && interfaceMethods !== undefined && interfaceMethods instanceof Array) {
            methodsLength = interfaceMethods.length;
            for (j = 0; j < methodsLength; j++) {
                method = interfaceMethods[j];
                if (methods.indexOf(method) === -1) {
                    methods.push(method);
                }
            }
        }
    }

    return methods;
};

exports.default = NavigationResponderBehaviors;
//# sourceMappingURL=NavigationResponderBehaviors.js.map